module.exports = ".background{\r\n    background-color: #003061;\r\n}"